export default __webpack_public_path__ + "static/media/DoneIcon.7ad4bbb3.svg";